import { render, staticRenderFns } from "./CardCabecera.vue?vue&type=template&id=b8e8cc04&scoped=true"
import script from "./CardCabecera.vue?vue&type=script&lang=js"
export * from "./CardCabecera.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b8e8cc04",
  null
  
)

export default component.exports